import { createSelector } from "reselect";

const getKnownPathogenicityData = (state) => {
  return __IS_COMPONENTS_PORTAL__
    ? state?.variantResult?.genes?.[state.selectedGeneIndexClinical]
        ?.saphetor_known_pathogenicity
    : state?.variantResult?.saphetor_known_pathogenicity;
};

const getKnownPathogenicityValues = createSelector(
  getKnownPathogenicityData,
  (result) => {
    const knownPathogenicityValues = {};

    if (result && result.items && result.items[0]) {
      knownPathogenicityValues.benign = result.items[0].benign;
      knownPathogenicityValues.uncertain = result.items[0].uncertain;
      knownPathogenicityValues.pathogenic = result.items[0].pathogenic;
      knownPathogenicityValues.cutoffFrequency =
        result.items[0].frequency_benign_threshold;
      return knownPathogenicityValues;
    }
    return null;
  }
);

export { getKnownPathogenicityData, getKnownPathogenicityValues };
